import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
import { useCountdown } from './useCountdown';
function TimeBlock({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <span className="inline-flex flex-col items-center" data-id="element-256">
      <span className="min-w-[2ch] rounded-md bg-black/40 px-1.5 py-0.5 font-mono text-sm font-bold tabular-nums text-white sm:text-base" data-id="element-257">
        {value}
      </span>
      <span className="mt-0.5 text-[8px] font-semibold uppercase tracking-widest text-white/60" data-id="element-258">
        {label}
      </span>
    </span>;
}
const TOTAL_LICENSES = 175;
const SOLD_PERCENT = 83;
const REMAINING = Math.round(TOTAL_LICENSES * (1 - SOLD_PERCENT / 100));
export function UrgencyBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div role="region" aria-label="Oferta de lanzamiento por tiempo limitado" className="sticky top-0 z-50 w-full border-b border-urgency/40 bg-gradient-to-r from-urgency-dark via-urgency to-urgency-dark shadow-glow-red" data-id="element-259">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-center gap-x-3 gap-y-1 px-3 py-2 text-center" data-id="element-260">
        <motion.span animate={{
        scale: [1, 1.18, 1]
      }} transition={{
        duration: 1.4,
        repeat: Infinity
      }} className="inline-flex items-center" data-id="element-261">
          <FlameIcon className="h-4 w-4 text-amber-200" aria-hidden="true" data-id="element-262" />
        </motion.span>
        <span className="text-[11px] font-extrabold uppercase tracking-wide text-white sm:text-xs" data-id="element-263">
          Oferta de lanzamiento:
        </span>
        <span className="text-[11px] text-white/90 sm:text-xs" data-id="element-264">
          El precio aumenta en
        </span>
        <span className="inline-flex items-center gap-1" aria-label={`${hours} horas ${minutes} minutos ${seconds} segundos`} data-id="element-265">
          <TimeBlock value={hours} label="hrs" data-id="element-266" />
          <span className="pb-3 font-mono text-sm font-bold text-white" data-id="element-267">:</span>
          <TimeBlock value={minutes} label="min" data-id="element-268" />
          <span className="pb-3 font-mono text-sm font-bold text-white" data-id="element-269">:</span>
          <TimeBlock value={seconds} label="seg" data-id="element-270" />
        </span>
        <span className="hidden text-[11px] text-white/90 sm:inline sm:text-xs" data-id="element-271">
          o al completar los próximos{' '}
          <strong className="font-bold text-white" data-id="element-272">50 pedidos</strong>.
        </span>

        {/* Stock progress: 175 total, 83% sold, remaining shown */}
        <span className="flex min-w-[170px] flex-col gap-0.5" aria-label={`${SOLD_PERCENT}% de las licencias vendidas, quedan ${REMAINING} de ${TOTAL_LICENSES}`} data-id="element-273">
          <span className="flex items-center justify-between text-[10px] font-bold text-white sm:text-[11px]" data-id="element-274">
            <span data-id="element-275">{SOLD_PERCENT}% vendidas</span>
            <span className="text-amber-200" data-id="element-276">
              Quedan {REMAINING} de {TOTAL_LICENSES}
            </span>
          </span>
          <span className="h-1.5 w-full overflow-hidden rounded-full bg-black/40 ring-1 ring-white/20" data-id="element-277">
            <motion.span initial={{
            width: 0
          }} animate={{
            width: `${SOLD_PERCENT}%`
          }} transition={{
            duration: 1.1,
            ease: 'easeOut'
          }} className="block h-full rounded-full bg-amber-300" data-id="element-278" />
          </span>
        </span>
      </div>
    </div>;
}